import React from 'react';
import picD from '../../assets/pic.webp';
import picT from '../../assets/pic-t.webp';
import picM from '../../assets/pic-m.webp';
import { trackButtonClick } from '../../utils/analytics';

const Hero = () => {
  return (
    <section id='top'>
      <div className='container tc'>
        <div className='s-40 sm-60'></div>
        <h1 className='title-intro'>
          Transform Your Career in Tech with Full German Government Support
        </h1>
        <div className='s-24'></div>
        <h3 className='title-intro-sub w-60 ma'>
          Master AI, Software Engineering, or Digital Design through our industry-mentored programs.<br />
          Study flexibly online and become job-ready—100% funded by Agentur für Arbeit.
        </h3>
        <div className='s-32'></div>
        <a 
          href='#cta' 
          className='button'
          onClick={() => trackButtonClick('Check Your Eligibility', 'hero')}
        >
          Check Your Eligibility
        </a>
        <div className='s-32'></div>
        <p className='title-mini'>
          Bildungsgutschein • Aufstiegs-BAföG • Qualifizierungschancengesetz • ESF Plus funding available
        </p>
        <div className='s-48'></div>
        <img
          src={picD}
          alt='Cources'
          width={1118}
          height={600}
          className='show-d'
        />
        <img
          src={picT}
          alt='Cources'
          width={940}
          height={504}
          className='show-t'
        />
        <img
          src={picM}
          alt='Cources'
          width={572}
          height={307}
          className='show-m'
        />
        <div className='s-48'></div>
      </div>
      <div className='back'></div>
    </section>
  );
};

export { Hero };
